<template>
  <div class="tx">
    <div class="tx_main">
      <img :src="img" alt="coin" class="tx_main_img" />
      <Text pattern="body1" :weight="600">
        <span
          :style="{
            textTransform: 'capitalize',
          }"
        >
          {{ name }}
        </span>
        <br />
        {{ $t("address") }}
      </Text>
    </div>
    <div class="tx_details">
      <div class="tx_details_item">
        <Text pattern="body2" color="#787878" :weight="500" :height="150">
          {{ $t("Address") }}
        </Text>
        <Text
          pattern="body2"
          :weight="600"
          :height="135"
          color="#8F42FF"
          wordBreak="break-all"
        >
          {{ address }}
        </Text>
        <div class="tx_details_buttons">
          <BaseButton
            type="shade"
            size="sm"
            class="tx_details_button"
            @click="onCopyHash(address)"
          >
            <BaseSvgIcon name="copy" class="icon" />
            {{ $t("CopyLink") }}
          </BaseButton>
          <BaseButton
            type="shade"
            size="sm"
            class="tx_details_button"
            @click="onShare(address)"
          >
            <BaseSvgIcon name="share" class="icon" />
            {{ $t("ShareIt") }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
import BaseButton from "@emcd-shared/base-button/BaseButton.vue";
import BaseSvgIcon from "@/shared/ui/BaseSvgIcon/BaseSvgIcon.vue";
import "@/assets/icons/SVG/copy.svg";
import "@/assets/icons/SVG/share.svg";
import "@/assets/icons/SVG/status.svg";
import { formatDate } from "@/shared/utils/format/date";
import { mapActions } from "vuex";

export default {
  name: "TxDetails",
  props: {
    img: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
  },
  components: {
    Text,
    BaseButton,
    BaseSvgIcon,
  },
  computed: {},
  data() {
    return {
      formatDate,
    };
  },
  methods: {
    ...mapActions("alerts", ["ADD_ALERT"]),
    onCopyHash(address) {
      navigator.clipboard.writeText(address);
      this.ADD_ALERT(this.$t("AddressCopied"));
    },
    async onShare(address) {
      try {
        await navigator.share({
          title: "Address",
          text: address,
        });
      } catch (err) {
        /* empty */
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tx {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 338px;
  max-width: 338px;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &_main {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 13px;
    padding-bottom: 24px;
    border-bottom: 1px solid #1a1a1a;

    &_img {
      width: 43px;
      height: 43px;
    }
  }

  &_details {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
    padding-top: 22px;

    &_item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    &_buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 8px;
      margin-top: 9px;
      width: 100%;

      .tx_details_button {
        background: transparent;
        border-color: #2d2d2d;
        color: #fff;
      }
    }

    &_button {
      width: 100%;
      justify-items: center;
      align-items: center;
    }

    &_status {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      border: 1px solid var(--Dark-700, #2d2d2d);
      background: var(--Dark-850, #1a1a1a);
      height: 43px;
      width: 100%;
      padding: 0 20px;

      &_success {
        border: 1px solid #43a047;
        color: #43a047;
      }
    }
  }
}

.line {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 1px;
  background: #1a1a1a;
}
</style>
